import type { ApiClient } from '@travel/api-client';
import env from '@travel/env';

import type { ResponseBody } from 'Banner-Types';
import { isServer } from 'core/httpClient';

export const fetch = async (http: ApiClient): Promise<ResponseBody> => {
  const url = (
    !isServer ? env('UNIVERSAL_BANNER_API_CLIENT_URL') : env('UNIVERSAL_BANNER_API_SERVER_URL')
  ) as string;

  return http.get(url, {
    ignoreCommonErrorHandler: true,
    isThirdPartyApi: !isServer,
  });
};
